import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const PaperIcon = ({ color }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height="16px"
			viewBox="0 0 16 16"
			fill="none"
		>
			<g clipPath="URL(#clip0_1181_2451)">
				<path
					d="M8.99316 1.85498H3.99316C3.66164 1.85498 3.3437 1.98668 3.10928 2.2211C2.87486 2.45552 2.74316 2.77346 2.74316 3.10498V13.105C2.74316 13.4365 2.87486 13.7544 3.10928 13.9889C3.3437 14.2233 3.66164 14.355 3.99316 14.355H11.4932C11.8247 14.355 12.1426 14.2233 12.377 13.9889C12.6115 13.7544 12.7432 13.4365 12.7432 13.105V5.60498L8.99316 1.85498Z"
					stroke={color}
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.99316 1.85498V5.60498H12.7432"
					stroke={color}
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10.2432 8.72998H5.24316"
					stroke={color}
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10.2432 11.23H5.24316"
					stroke={color}
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.49316 6.22998H5.86816H5.24316"
					stroke={color}
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1181_2451">
					<rect
						width="15"
						height="15"
						fill={color}
						transform="translate(0.243164 0.60498)"
					/>
				</clipPath>
			</defs>
		</Icon>
	);
};
